import { Button, Col, Container, Modal, Row } from 'react-bootstrap';
import styled, { useTheme } from 'styled-components';

import ErrorDisc from '../../../assets/svg/disc/error-disc.svg';
import { SpacerHr } from '../../Styled';

const StyledDarkButton = styled(Button)`
  background-color: ${(props) => props.theme.colors.light};
  border-color: ${(props) => props.theme.colors.light};

  &:hover {
    background-color: ${(props) => props.theme.colors.grey};
    border-color: ${(props) => props.theme.colors.grey};
  }
`;

const ErrorModal = ({ show, onNext, onCancel, onSupport }) => {
  const theme = useTheme();
  return (
    <Modal aria-labelledby="contained-modal-title-vcenter" centered show={show}>
      <Modal.Body className="p-4">
        <Container fluid>
          <Row>
            <Col className="text-center pb-2">
              <h1 className="pb-2">Error updating tariff information</h1>
              <p className="p-2">
                <img src={ErrorDisc} />
              </p>
              <p>There's been an error updating your tariff information.</p>
              <Button onClick={onNext} className="w-100">
                Try again
              </Button>
              <StyledDarkButton className="mb-2 w-100" variant="dark" onClick={onCancel}>
                Cancel
              </StyledDarkButton>
              <SpacerHr label="or" />
              <Button variant="secondary" onClick={onSupport} className="w-100">
                Contact {theme.language.appName} Support
              </Button>
            </Col>
          </Row>
        </Container>
      </Modal.Body>
    </Modal>
  );
};

export default ErrorModal;
